import { Component, Input, OnInit } from '@angular/core';
import { HealthModels } from '@wz-models';

@Component({
  selector: 'infobulle-details-garanties',
  templateUrl: './infobulle-details-garanties.component.html',
  styleUrls: ['./infobulle-details-garanties.component.scss'],
  standalone: false,
})
export class InfobulleDetailsGarantiesComponent implements OnInit {
  @Input() besoinsType: string = '';

  detailsGarantiesMinimum: string = '';
  detailsGarantiesMoyen: string = '';
  detailsGarantiesFort: string = '';
  detailsGarantiesMaximum: string = '';

  test: string = '';

  constructor() {}

  ngOnInit() {
    this.setDetailsTexteGarantie();
  }

  setDetailsTexteGarantie() {
    //Soins Medicaux
    if (this.besoinsType == HealthModels.BesoinsTypeIGDEnum.Medecin) {
      this.detailsGarantiesMinimum =
        'Vous consultez des médecins ne pratiquant pas de dépassement d’honoraires et/ou je souhaite des remboursements à hauteur de 100% de la base de remboursement c’est-à-dire une prise en charge limité au ticket modérateur.';
      this.detailsGarantiesMoyen =
        'Vous consultez des médecins pratiquant de faibles dépassements d’honoraires. Je souhaite une prise en charge entre 101% et 150% de la base de remboursement.';
      this.detailsGarantiesFort =
        'Vous consultez des médecins pratiquant de forts dépassements d’honoraires. Je souhaite une prise en charge entre 151% et 200% de la base de remboursement.';
      this.detailsGarantiesMaximum =
        'Vous consultez des médecins pratiquant de très forts dépassements d’honoraires. Je souhaite une prise en charge de plus de 200% de la base de remboursement pour avoir le moins de reste à charge possible.';
    }
    //Hospitalisation
    if (this.besoinsType == HealthModels.BesoinsTypeIGDEnum.Hospitalisation) {
      this.detailsGarantiesMinimum =
        'Vous souhaitez une prise en charge minimum et ne pas bénéficier d’une chambre particulière. La prise en charge des honoraires sera inférieure ou égale à 100% de la base de remboursement c’est-à-dire limité au ticket modérateur.';
      this.detailsGarantiesMoyen =
        'Vous souhaitez une couverture moyenne des honoraires et de la chambre particulière. Votre prise en charge sera comprise entre 101% et 150% de la base de remboursement.';
      this.detailsGarantiesFort =
        'Vous souhaitez une forte couverture des honoraires et de la chambre particulière. Votre prise en charge sera comprise entre 151% et 200% de la base de remboursement.';
      this.detailsGarantiesMaximum =
        'Vous souhaitez une couverture maximum des honoraires et de la chambre particulière. Votre prise en charge sera supérieure à 200% de la base de remboursement.';
    }
    //Dentaire
    if (this.besoinsType == HealthModels.BesoinsTypeIGDEnum.Dentaire) {
      this.detailsGarantiesMinimum =
        'Vous consultez uniquement pour les rendez-vous de contrôle (détartrage, caries…) et vous souhaitez une prise en charge minimum.';
      this.detailsGarantiesMoyen =
        'Vous envisagez la pose de prothèses dentaires et vous souhaitez une couverture moyenne. Votre prise en charge sera comprise entre 101% et 200% de la base de remboursement.';
      this.detailsGarantiesFort =
        'Vous envisagez la pose de prothèses dentaires et souhaitez une forte couverture. Votre prise en charge sera comprise entre 201% et 300% de la base de remboursement.';
      this.detailsGarantiesMaximum =
        'Vous envisagez la pose de prothèses dentaires ou d’implants et souhaitez une couverture maximum. Votre prise en charge sera supérieure à 300% de la base de remboursement.';
    }
    //optique
    if (this.besoinsType == HealthModels.BesoinsTypeIGDEnum.Optique) {
      this.detailsGarantiesMinimum =
        'Vous ne portez pas de lunettes ni de lentilles et ne souhaitez pas de prise en charge. Votre couverture sera inférieure ou égale à 100€/an.';
      this.detailsGarantiesMoyen =
        'Vous portez des lunettes à verres simples ou complexes et/ou des lentilles et chercher une prise en charge moyenne. Votre couverture sera comprise entre 101€ et 200€ par an.';
      this.detailsGarantiesFort =
        'Vous portez des lunettes à verres simples ou complexes et/ou des lentilles et chercher une forte prise en charge. Votre couverture sera comprise entre 201€ et 300€ par an.';
      this.detailsGarantiesMaximum =
        'Vous portez des lunettes à verres simples ou complexes et/ou des lentilles et chercher une prise en charge maximum. Votre couverture sera supérieure à 300€ par an.';
    }
    //Auditif
    if (this.besoinsType == HealthModels.BesoinsTypeIGDEnum.Auditif) {
      this.detailsGarantiesMinimum =
        'Vous n’avez pas de problème auditif et ne souhaitez pas de prise en charge. Votre couverture sera inférieure ou égale à 100€/an.';
      this.detailsGarantiesMoyen =
        'Vous envisagez l’acquisition d’un appareil auditif vous permettant simplement de résoudre votre problème auditif. Votre couverture sera comprise entre 101€ et 300€ par an.';
      this.detailsGarantiesFort =
        'Vous envisagez l’acquisition d’un appareil auditif vous permettant de résoudre votre problème auditif tout en étant discret et esthétique. Votre couverture sera comprise entre 301€ et 500€ par an.';
      this.detailsGarantiesMaximum =
        'Vous envisagez l’acquisition d’un appareil auditif vous permettant de résoudre votre problème auditif tout en étant discret et esthétique. Votre couverture sera comprise entre 301€ et 500€ par an. Votre couverture sera supérieure à 500€ par an.';
    }
  }
}
